const url = window.location.href;
// eslint-disable-next-line no-useless-escape
const matches: any = url.match(/^http(s?)?\:\/\/([^\/?#]+)/);
const baseUrl = matches[0];
const websocketUrl = baseUrl.replace('http', 'ws') + '/ws/';

export const environment = {
  production: true,
  baseUrl,
  websocketUrl,
  sentry: {
    // this variable will be replace in gitlab ci/cd. see more in file .gitlab-ci/5-tag-prod.gitlab-ci.yml
    dsn: 'https://6e1317e9d5c4c5d182863d4f07a87065@sentry.c0d1um.io/222',
    environment: 'PROD_FE',
    debug: false,
  },
};

export const featureFlag: any = {
  page_title: '',
  ddoc: false,
  memo_enable: false,
  econtract_enable: false,
  budget_enable: false,
  ddoc_enable_feature_26: false,
  ddoc_enable_feature_28: false,
  timestamp_memo_enable: false,
  ndid: false,
  login_adfs_enable: false,
  thaid_login_enable: false,
  maintenance_mode: false,
  maintenance_message_th: '',
  maintenance_message_en: '',
  sms_otp: false,
  email_otp: false,
  thaicom: false,
  saved_filter_enable: false,
  self_service_form: false,
  auto_widget_enable: false,
  google_client_id: '',
  export_memo_google_drive_enable: false,
  contract_ddoc: false,
  contract_ddoc_enable_feature_26: false,
  contract_ddoc_enable_feature_28: false,
  contract_timestamp_memo_enable: false,
  contract_sms_otp: false,
  contract_email_otp: false,
  contract_ndid: false,
  contract_thaicom: false,
  media_url_need_authentication: true,
  share_folder_enable: false,
  multi_approval_enable: false,
  company_name: '',
  carbon_accounting_enable: false,
  download_detail_enable: false,
  loh_enable: false,
  google_chat_notification_enable: false,
  microsoft_teams_notification_enable: false,
  memo_save_all_version_history: false,
  save_thumbnail_memo: true,
  enable_pdf_repairing: false,
};
